import React from "react";
import "./PrivacyPolicy.css";

const RefundPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1>Refund & Cancellation Policy</h1>

        <section>
          <h2>Order Cancellation</h2>

          <p>
            Orders can be cancelled before they are shipped.
          </p>

          <p>
            Once shipped, cancellation requests may not be accepted.
          </p>
        </section>

        <section>
          <h2>Returns & Exchanges</h2>

          <p>
            Customers may request a return or exchange within 7 days of
            delivery in the following cases:
          </p>

          <ul>
            <li>Wrong product delivered</li>
            <li>Damaged product received</li>
            <li>Size issue (if exchange is available)</li>
          </ul>
        </section>

        <section>
          <h2>Conditions for Return</h2>

          <p>Products must be:</p>

          <ul>
            <li>Unused</li>
            <li>In original packaging</li>
            <li>With tags intact</li>
          </ul>
        </section>

        <section>
          <h2>Non-Returnable Items</h2>

          <p>The following items are not eligible for return:</p>

          <ul>
            <li>Used products</li>
            <li>Products damaged by customers</li>
            <li>Items without original packaging</li>
          </ul>
        </section>

        <section>
          <h2>Refund Process</h2>

          <p>
            Approved refunds are processed within 5–7 business days to the
            original payment method.
          </p>
        </section>

        <section>
          <h2>Contact for Returns</h2>

          <div className="contact-box">
            <p>Email: support@sapra.com</p>
            <p>Phone: +91 9876543210</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default RefundPolicy;